import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ChevronLeft, ChevronRight, Quote, Star } from 'lucide-react';
const testimonials = [{
  name: 'James Mitchell',
  role: 'CEO, TransfrInc',
  quote: 'Byteweb delivered a polished corporate website that captured our brand with real clarity. Their attention to detail and understanding of the customer experience made the process seamless.',
  rating: 5
}, {
  name: 'Sarah van der Merwe',
  role: 'Founder, EcoMinim',
  quote: 'The Byteweb team created a fast, responsive e-commerce experience that customers genuinely enjoy using. The platform gave us a stronger foundation for growth from day one.',
  rating: 5
}, {
  name: 'David Okonkwo',
  role: 'Director, BENS',
  quote: 'Byteweb developed a custom plugin that streamlined our operations significantly. The team was thoughtful, communicative and delivered ahead of schedule.',
  rating: 5
}, {
  name: 'Lisa Chen',
  role: 'Marketing Lead, Cloudit',
  quote: 'Our new website transformed how clients experience our brand. Byteweb understood the brief, brought a strong point of view and executed with care.',
  rating: 5
}];
export function TestimonialsSection() {
  const [current, setCurrent] = useState(0);
  const previous = () => setCurrent(index => index === 0 ? testimonials.length - 1 : index - 1);
  const next = () => setCurrent(index => index === testimonials.length - 1 ? 0 : index + 1);
  return <section id="testimonials" className="relative bg-dark py-24" data-id="element-336">
      <div className="mx-auto max-w-[1320px] px-4" data-id="element-337">
        <div className="mb-16 text-center" data-id="element-338">
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="mb-3 font-inter text-xs font-bold uppercase tracking-[0.2em] text-gold" data-id="element-339">
            Client stories
          </motion.p>
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="font-syne text-4xl font-bold text-white md:text-5xl" data-id="element-340">
            Trusted to make the digital{' '}
            <span className="text-gold" data-id="element-341">experience count.</span>
          </motion.h2>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="mx-auto mt-4 max-w-xl font-inter text-white/60" data-id="element-342">
            A few words from the teams who have trusted Byteweb with important
            digital work.
          </motion.p>
        </div>

        <div className="relative mx-auto max-w-3xl" data-id="element-343">
          <div className="mb-8 flex justify-center" data-id="element-344">
            <div className="flex h-16 w-16 items-center justify-center rounded-full border border-gold/20 bg-gold/10" data-id="element-345">
              <Quote className="h-7 w-7 text-gold" data-id="element-346" />
            </div>
          </div>

          <div className="relative flex min-h-[290px] items-center" data-id="element-347">
            <AnimatePresence mode="wait" data-id="element-348">
              <motion.article key={testimonials[current].name} initial={{
              opacity: 0,
              y: 20
            }} animate={{
              opacity: 1,
              y: 0
            }} exit={{
              opacity: 0,
              y: -20
            }} transition={{
              duration: 0.35
            }} className="w-full rounded-2xl border border-white/5 bg-dark-lighter p-8 text-center md:p-12" aria-live="polite" data-id="element-349">
                <div className="mb-6 flex items-center justify-center gap-1" data-id="element-350">
                  {Array.from({
                  length: testimonials[current].rating
                }).map((_, index) => <Star key={index} size={18} className="fill-gold text-gold" aria-hidden="true" data-id="element-351" />)}
                </div>
                <blockquote className="font-inter text-lg leading-relaxed text-white/80 md:text-xl" data-id="element-352">
                  “{testimonials[current].quote}”
                </blockquote>
                <footer className="mt-8" data-id="element-353">
                  <p className="font-syne text-lg font-bold text-white" data-id="element-354">
                    {testimonials[current].name}
                  </p>
                  <p className="mt-1 font-inter text-sm text-white/50" data-id="element-355">
                    {testimonials[current].role}
                  </p>
                </footer>
              </motion.article>
            </AnimatePresence>
          </div>

          <div className="mt-8 flex items-center justify-center gap-4" data-id="element-356">
            <button type="button" onClick={previous} className="flex h-11 w-11 items-center justify-center rounded-full border border-white/10 text-white/60 transition-colors hover:border-gold hover:text-gold focus:outline-none focus:ring-2 focus:ring-gold" aria-label="Previous client story" data-id="element-357">
              <ChevronLeft size={20} data-id="element-358" />
            </button>

            <div className="flex items-center gap-2" data-id="element-359">
              {testimonials.map((testimonial, index) => <button key={testimonial.name} type="button" onClick={() => setCurrent(index)} className={`h-2.5 rounded-full transition-all duration-300 ${index === current ? 'w-6 bg-gold' : 'w-2.5 bg-white/20 hover:bg-white/40'}`} aria-label={`Show story from ${testimonial.name}`} aria-current={index === current ? 'true' : undefined} data-id="element-360" />)}
            </div>

            <button type="button" onClick={next} className="flex h-11 w-11 items-center justify-center rounded-full border border-white/10 text-white/60 transition-colors hover:border-gold hover:text-gold focus:outline-none focus:ring-2 focus:ring-gold" aria-label="Next client story" data-id="element-361">
              <ChevronRight size={20} data-id="element-362" />
            </button>
          </div>
        </div>
      </div>
    </section>;
}